export interface ICheckBox {
  id: number;
  value: string;
  des: string;
}

export interface CustomTabProps {
  label: string;
  total?: number;
  id: number;
  value?: number;
  data?: any;
}

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export interface Timestamp {
  seconds: number;
  nanoseconds: number;
}

export interface CustomPagination {
  data: any;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
}

export interface DateTime {
  date: string;
  slashDate: string;
  time: string;
  fullDateTime: string;
  japaneseDate: string;
}

interface LanguageData {
  KEY_VALUE: string;
}

export interface ILanguage {
  [key: string]: LanguageData;
}

export enum OrderItemStatus {
  NEW = 'NEW',
  PREPARING = 'PREPARING',
  READY_FOR_PICK_UP = 'READY_FOR_PICK_UP',
  WAIT_FOR_PICK_UP = 'WAIT_FOR_PICK_UP',
  DELIVERED = 'DELIVERED',
  DELIVERING = 'DELIVERING',
  DAMAGED_PREPARING = 'DAMAGED_PREPARING',
  DAMAGED_READY_FOR_PICK_UP = 'DAMAGED_READY_FOR_PICK_UP',
  DAMAGED_DELIVERING = 'DAMAGED_DELIVERING',
  CANCELLED = 'CANCELLED',
}

export enum DamagedItemStatus {
  DAMAGED_CREATED = 'DAMAGED_CREATED',
  DAMAGED_PREPARING = 'DAMAGED_PREPARING',
  DAMAGED_READY_FOR_PICK_UP = 'DAMAGED_READY_FOR_PICK_UP',
  DAMAGED_DELIVERING = 'DAMAGED_DELIVERING',
  DAMAGED_DELIVERED = 'DAMAGED_DELIVERED',
  DAMAGED_CANCELLED = 'DAMAGED_CANCELLED',
}

export enum TopicName {
  RIDER = 'RIDER',
  MANAGE = 'MANAGE',
}

export enum PaymentMethod {
  Credit = 'CREDIT_CARD',
  Mobile = 'MOBILE_PAYMENT',
}

export interface IRestaurants {
  id: string;
  name: string;
  merchant_id: string;
}

export interface OrderSummaryData {
  totalOrders: number;
  totalDeliveryFee: number;
  totalOrderAmount: number;
  totalFoodRevenue: number;
  totalDamagedFee: number;
  totalWithServiceCharge: number;
  totalBenefit: number;
  totalDeliveredOrder: number;
  totalDamagedOrder: number;
  totalCancelledOrder: number;
}

export interface ITableSummary {
  style: string;
  tableCell: string;
  showForSuperAdmin: boolean;
  data: {
    [key: string]: OrderSummaryData | null;
  };
  selectedFoodTrucks: string[];
  onFilterChange: (selectedFoodTrucks: string[]) => void;
  routeType?: 'pre_orders' | 'order_history' | string;
}

export enum BillStatus {
  NOT_CLEARED = 'NOT_CLEARED',
  BILL_CANCELLED_AS_SHOP_CLOSED = 'BILL_CANCELLED_AS_SHOP_CLOSED',
  CLEARED = 'CLEARED',
}

export type ParsedCSVData = string[][];
